var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "not-found" } }, [
    _c("div", { staticClass: "sectionheader" }, [
      _c("h1", [_vm._v("404")]),
      _c("h5", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.generalLabel.NOT_PUBLISH_PAGE_MESSAGE) +
            "\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }